module.exports = "https://static.wmbcdn.com/uniweb/images/c7ad47f313ecfc22bd26ae6e96c0f8fa.svg";